import React, { ReactNode, useRef } from 'react'
import { AppBar, AppBarProps, Box, Button, ClickAwayListener, IconButton, styled, Toolbar } from '@mui/material'

import { AccountCircle, ArrowDropDown, Menu } from '@mui/icons-material'
import { setSidebarOpen, useProfile, useSidebarWidth } from '@store/app'
import HeaderNavMenu from '@components/Layout/HeaderNavMenu'
import { useAuthContext } from '@src/providers/AuthProvider'
import { useAppDispatch, useIsMobile, useIsTablet } from '@src/hooks'

export type HeaderProps = AppBarProps & {
  children?: ReactNode;
  height?: number;
}

const Header = styled(({ children, sx, ...props }: HeaderProps) => {
  const profile = useProfile()
  const sideBarWidth = useSidebarWidth()
  const { signOut } = useAuthContext()
  const isTablet = useIsTablet()
  const isMobile = useIsMobile()
  const dispatch = useAppDispatch()
  const menuRef = useRef<HTMLElement | null>(null)

  const showSideBarHandler = () => {
    dispatch(setSidebarOpen(true))
  }

  const openMenuHandler = (e: React.MouseEvent<HTMLElement>) => {
    if(!isTablet) {
      return
    }

    const target = e.target as HTMLElement
    target.closest('.HeaderNavMenu')!.classList.toggle('active')
  }

  const closeMenuHandler = () => {
    if(menuRef.current) {
      menuRef.current.classList.remove('active')
    }
  }

  sx = Object.assign({}, sx || {}, {
    width: `calc(100% - ${sideBarWidth}px)`,
    marginLeft: `${sideBarWidth}px`,
    justifyContent: isTablet ? 'start' : 'space-between',
  })

  return (
    <AppBar {...props} sx={sx} position={isMobile && profile ? 'sticky' : 'static'}>
      <Toolbar>
        {isTablet && profile && (
          <IconButton size='small' color='inherit' onClick={showSideBarHandler}
                      className='HeaderSidebarShowButton'>
            <Menu />
          </IconButton>
        )}

        {children}

        {profile && (
          <ClickAwayListener onClickAway={closeMenuHandler}>
            <HeaderNavMenu ref={menuRef}>
              <Box onClick={openMenuHandler} sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountCircle sx={{ mr: 0.75 }} fontSize='small' />
                {!isTablet && profile.name}
                <ArrowDropDown color='inherit' sx={{ ml: isTablet ? 0 : 0.5 }} />
              </Box>
              <Box className='appHeaderNavMenu'>
                <Button variant='text' disableRipple onClick={signOut}>
                  Выйти
                </Button>
              </Box>
            </HeaderNavMenu>
          </ClickAwayListener>
        )}
      </Toolbar>
    </AppBar>
  )
})(({ theme: { spacing }, height = 65 }) => ({
  '.MuiToolbar-root': {
    minHeight: `${height}px`,
    alignItems: 'center',
    paddingTop: spacing(2),
    paddingBottom: spacing(2),
    boxSizing: 'border-box',
  }
}))

export default Header